import { STRAPI_URL, parseErrorMessage, strapiAuthHeaders } from '../../api/strapi';
import { rowSelectionDocumentIds } from './formQuestionMapJenis';

export type MapOptionsToQuestionsResult = {
  updated_count: number;
  form_question_count: number;
};

export async function strapiMapFormQuestionOptionsToQuestions(
  jwt: string,
  input: { formQuestionOptionDocumentIds: string[]; formQuestionDocumentIds: string[] },
): Promise<MapOptionsToQuestionsResult> {
  const optionIds = rowSelectionDocumentIds(input.formQuestionOptionDocumentIds);
  if (!optionIds.length) throw new Error('Pilih minimal satu form question option.');
  const questionIds = rowSelectionDocumentIds(input.formQuestionDocumentIds);
  if (!questionIds.length) throw new Error('Pilih minimal satu pertanyaan.');

  const res = await fetch(`${STRAPI_URL}/api/form-question-options/map-options-to-questions`, {
    method: 'POST',
    headers: {
      ...(strapiAuthHeaders(jwt) as Record<string, string>),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      form_question_option_document_ids: optionIds,
      form_question_document_ids: questionIds,
    }),
  });
  const body = (await res.json().catch(() => ({}))) as unknown;
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
  const data =
    body && typeof body === 'object' && 'data' in body
      ? (body as { data?: Record<string, unknown> }).data
      : null;
  return {
    updated_count: Number(data?.updated_count ?? 0),
    form_question_count: Number(data?.form_question_count ?? 0),
  };
}
